(function () {
    "use strict";

    var app = angular.module("dnapp");

    function MailingListSubscribeController(mailingListService) {

        var ctrl = this;
        ctrl.submitted = false;
        ctrl.showEmailConfirm = false;

        ctrl.subscriber = {
            FirstName: "",
            LastName: "",
            Email: "",
            Lists: []
        }

        ctrl.initLists = function (lists) {
            ctrl.lists = lists;
            if (ctrl.lists.length == 1) {
                ctrl.subscriber.Lists.push(ctrl.lists[0]);
            }
        }

        ctrl.toggleCheck = function (list) {
            if (ctrl.subscriber.Lists.indexOf(list) === -1) {
                ctrl.subscriber.Lists.push(list);
            } else {
                ctrl.subscriber.Lists.splice(ctrl.subscriber.Lists.indexOf(list), 1);
            }
        };

        ctrl.subscribe = function (form) {
            form.$setSubmitted();
            if (!form.$valid) {
                return;
            }
            mailingListService.Subscribe(ctrl.subscriber)
                .$promise.then(function (response) {
                    ctrl.submitted = true;
                    var mc = response.filter(function (list) {
                        return list.ProviderId == "mailchimp";
                    })
                    if (mc.length > 0) {
                        ctrl.showEmailConfirm = true;
                    }
                },
                    function (error) { console.warn("bad things happened", error); });
        }

    };
    app.controller("DN.MailingListSubscribeController", ["DN.MailingListService", MailingListSubscribeController]);

    function MailingListUnsubscribeController(mailingListService, $location, $scope) {
        var ctrl = this;
        var lists = [];
        var provider = null;
        var lists_init = false;
        var provider_init = false;
        var email = $location.search().email;

        ctrl.selected = [];
        ctrl.result = [];
        ctrl.submitted = false;

        ctrl.initLists = function (l) {
            lists = l;
            lists_init = true;
            init();
        }

        ctrl.initProvider = function (p) {
            if (p && p.length > 0) { provider = p; }
            provider_init = true;
            init();
        }

        ctrl.unSubscribe = function () {
            if (ctrl.selected.length == 0) return;

            mailingListService.UnSubscribe({ Email: email, Lists: ctrl.selected })
                .$promise.then(function (response) {
                    ctrl.submitted = true;
                    ctrl.result = response;
                },
                    function (error) { console.warn("bad things happened", error); });
        }

        ctrl.toggleSubscription = function (list) {
            list.unsubscribe = !list.unsubscribe;
            ctrl.selected = ctrl.subscriptions.filter(function (s) {
                return s.unsubscribe;
            })
        };

        function init() {
            if (lists_init && provider_init) {
                if (lists.length > 0) { setProviders(); }
                if (email) { getSubscriptions(); }
            }
        }

        function setProviders() {
            var providers = [];
            loop1: for (var i = 0; i < lists.length; i++) {
                var providerId = lists[i].ProviderId;
                for (var i2 = 0; i2 < providers.length; i2++) {
                    if (providers[i2] == providerId) {
                        continue loop1;
                    }
                }
                providers.push(providerId);
            }
            if (providers.length == 1) {
                provider = providers[0];
            }
        }

        function getSubscriptions() {
            var request = { email: email }
            if (provider) {
                request.providerId = provider;
            }
            mailingListService.Subscriptions(request).$promise.then(function (subscriptions) {
                if (lists.length > 0) {
                    ctrl.subscriptions = subscriptions.filter(function (s) {
                        var f = lists.find(function (l) {
                            return s.Id == l.Id && s.ProviderId == l.ProviderId
                        });
                        return typeof f !== 'undefined';
                    })
                } else {
                    ctrl.subscriptions = subscriptions;
                }
            },
                function (error) {
                    console.warn("bad things happened", error);
                });

        }

    }
    app.controller("DN.MailingListUnsubscribeController", ["DN.MailingListService", "$location", "$scope", MailingListUnsubscribeController]);


})();